import React from 'react'

const HomeAbout = () => {
  return (
    <div className='backdiv'>
         <h2 className='main_heading'>ABOUT US</h2>
        <div className='homeabout_grid'>
<div className='homeabout_imgdiv'>
<img src="/homeabt.webp" alt="About Us" className='zweedo_img' loading='lazy'/>
</div>
<div>
 <p className='main_content'>At our core, we are a dedicated team of data-driven marketing experts committed to optimizing every dollar you invest. We start by truly understanding your goals, listening carefully before recommending the marketing channels most likely to deliver real, measurable results. From local startups to global enterprises, we’ve helped countless businesses stop wasting budget on ineffective campaigns.
<br/>
When partnering with new clients, we prioritize understanding your unique objectives. We design tailored tests across selected channels, analyze the outcomes, and continuously shift your budget towards the highest-performing strategies. This iterative approach of listen, test, and optimize has earned us loyal clients who confidently know how their marketing budget is working for them.
<br/>
We value transparency and clear communication, making the process seamless and straightforward for our clients.

</p>
<div className='btn_div'>
  <a href='/about-us'>
  <button className='read_btn'>Read more</button></a>
</div>
</div>
        </div>

    </div>
  )
}

export default HomeAbout